import OpsLayout from '/@/modules/ops/OpsLayout.vue';
import { OpsRouteConfig } from '/@/modules/ops/routes/OpsRouteConfig';
import { router as opsEstateRoutes } from '@/modules/ops/routes/ops.estate.router';
import { router as opsAdminRoutes } from '/@/modules/admin/routes/ops.admin.router';
import { router as opsNotificationRoutes } from '/@/modules/notification/routes/ops.notification.router';
import { router as opsAuditRoutes } from '/@/modules/audit/routes/ops.audit.router';
import { OpsRoute } from '/@/modules/ops/constants/OpsRoute';

export const router = [
  OpsRouteConfig.factory({
    name: OpsRoute.OPS,
    path: `/${OpsRoute.OPS}`,
    component: OpsLayout,
    children: [...opsEstateRoutes, ...opsAdminRoutes, ...opsAuditRoutes, ...opsNotificationRoutes],
    meta: { authOnly: true }
  }).build()
];
